import React from 'react';
import './Admissions.css';

const Admissions = () => {
  return (
    <div className="admissions">
      {/* Hero Section */}
      <section className="admissions-hero">
        <div className="container">
          <h1>Admissions</h1>
          <p className="hero-subtitle">Join Our Community of Excellence</p>
        </div>
      </section>

      {/* Admission Process */}
      <section className="admission-process">
        <div className="container">
          <h2>Admission Process</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Application</h3>
                <p>Submit your application form along with required documents and application fee.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Assessment</h3>
                <p>Students will be assessed through written tests and interviews to determine their academic level.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Review</h3>
                <p>Our admissions committee reviews all applications and assessment results.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Acceptance</h3>
                <p>Successful candidates receive admission letters and enrollment instructions.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Requirements */}
      <section className="requirements">
        <div className="container">
          <h2>Admission Requirements</h2>
          <div className="requirements-grid">
            <div className="requirement-card">
              <div className="requirement-icon">📋</div>
              <h3>Application Form</h3>
              <ul>
                <li>Completed application form</li>
                <li>Recent passport photograph</li>
                <li>Birth certificate</li>
                <li>Previous school reports</li>
              </ul>
            </div>
            <div className="requirement-card">
              <div className="requirement-icon">📚</div>
              <h3>Academic Records</h3>
              <ul>
                <li>Previous academic transcripts</li>
                <li>Transfer certificate (if applicable)</li>
                <li>Recommendation letters</li>
                <li>Medical certificate</li>
              </ul>
            </div>
            <div className="requirement-card">
              <div className="requirement-icon">💰</div>
              <h3>Financial Documents</h3>
              <ul>
                <li>Payment of application fee</li>
                <li>Proof of financial capability</li>
                <li>Sponsor's letter (if applicable)</li>
                <li>Bank statements</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Age Requirements */}
      <section className="age-requirements">
        <div className="container">
          <h2>Age Requirements</h2>
          <div className="age-table">
            <div className="age-row header">
              <div className="age-level">Level</div>
              <div className="age-range">Age Range</div>
              <div className="age-requirements">Requirements</div>
            </div>
            <div className="age-row">
              <div className="age-level">Nursery</div>
              <div className="age-range">2-3 years</div>
              <div className="age-requirements">Birth certificate, Medical clearance</div>
            </div>
            <div className="age-row">
              <div className="age-level">Kindergarten</div>
              <div className="age-range">4-5 years</div>
              <div className="age-requirements">Birth certificate, Previous school report</div>
            </div>
            <div className="age-row">
              <div className="age-level">Primary 1</div>
              <div className="age-range">5-6 years</div>
              <div className="age-requirements">Birth certificate, Assessment test</div>
            </div>
            <div className="age-row">
              <div className="age-level">JSS 1</div>
              <div className="age-range">11-12 years</div>
              <div className="age-requirements">Primary 6 certificate, Entrance exam</div>
            </div>
            <div className="age-row">
              <div className="age-level">SSS 1</div>
              <div className="age-range">14-15 years</div>
              <div className="age-requirements">JSS 3 certificate, Entrance exam</div>
            </div>
          </div>
        </div>
      </section>

      {/* Fees */}
      <section className="fees">
        <div className="container">
          <h2>School Fees</h2>
          <div className="fees-grid">
            <div className="fee-card">
              <h3>Early Years</h3>
              <div className="fee-amount">₦150,000</div>
              <div className="fee-period">per term</div>
              <ul>
                <li>Nursery & Kindergarten</li>
                <li>Includes meals</li>
                <li>Learning materials</li>
                <li>Extracurricular activities</li>
              </ul>
            </div>
            <div className="fee-card">
              <h3>Primary</h3>
              <div className="fee-amount">₦180,000</div>
              <div className="fee-period">per term</div>
              <ul>
                <li>Primary 1-6</li>
                <li>Textbooks included</li>
                <li>Sports activities</li>
                <li>Computer classes</li>
              </ul>
            </div>
            <div className="fee-card">
              <h3>Junior Secondary</h3>
              <div className="fee-amount">₦220,000</div>
              <div className="fee-period">per term</div>
              <ul>
                <li>JSS 1-3</li>
                <li>Laboratory fees</li>
                <li>Library access</li>
                <li>Career guidance</li>
              </ul>
            </div>
            <div className="fee-card">
              <h3>Senior Secondary</h3>
              <div className="fee-amount">₦250,000</div>
              <div className="fee-period">per term</div>
              <ul>
                <li>SSS 1-3</li>
                <li>WAEC/NECO preparation</li>
                <li>University counseling</li>
                <li>Leadership programs</li>
              </ul>
            </div>
          </div>
          <div className="fees-note">
            <p><strong>Note:</strong> Fees are subject to change. Additional charges may apply for specific programs and activities.</p>
          </div>
        </div>
      </section>

      {/* Scholarships */}
      <section className="scholarships">
        <div className="container">
          <h2>Scholarships & Financial Aid</h2>
          <div className="scholarship-content">
            <p>
              The MINT School is committed to making quality education accessible to deserving students. 
              We offer various scholarship programs and financial aid options to support families in need.
            </p>
            <div className="scholarship-types">
              <div className="scholarship-card">
                <div className="scholarship-icon">🏆</div>
                <h3>Academic Excellence</h3>
                <p>Merit-based scholarships for students with outstanding academic performance.</p>
                <div className="scholarship-details">
                  <span>Up to 50% tuition reduction</span>
                </div>
              </div>
              <div className="scholarship-card">
                <div className="scholarship-icon">💝</div>
                <h3>Need-Based Aid</h3>
                <p>Financial assistance for families facing economic challenges.</p>
                <div className="scholarship-details">
                  <span>Up to 75% tuition reduction</span>
                </div>
              </div>
              <div className="scholarship-card">
                <div className="scholarship-icon">🎯</div>
                <h3>Special Talents</h3>
                <p>Scholarships for students with exceptional talents in sports, arts, or leadership.</p>
                <div className="scholarship-details">
                  <span>Up to 40% tuition reduction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="application-form">
        <div className="container">
          <h2>Apply Now</h2>
          <div className="form-content">
            <p>Ready to join The MINT School? Download our application form and submit it with the required documents.</p>
            <div className="form-actions">
              <button className="btn btn-primary" onClick={() => alert('Application form download will be available soon!')}>
                Download Application Form
              </button>
              <a href="/contact" className="btn btn-secondary">
                Contact Admissions Office
              </a>
            </div>
            <div className="contact-info">
              <h3>Admissions Office</h3>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <span>+234 XXX XXX XXXX</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">✉️</span>
                  <span>admissions@themintschool.edu.ng</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <span>Asa-Otukpo, Benue State</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Admissions;
